const ConsumptionOverview = () =>
  import(
    /* webpackChunkName: "business" */ '@/views/business/ConsumptionOverview.vue'
  )
const MySalesPerformance = () =>
  import(
    /* webpackChunkName: "business" */ '@/views/business/MySalesPerformance.vue'
  )
const Postpaid = () =>
  import(/* webpackChunkName: "business" */ '@/views/business/Postpaid.vue')
const prepaymentList = () =>
  import(
    /* webpackChunkName: "business" */ '@/views/business/prepayment/List.vue'
  )
const prepaymentDetail = () =>
  import(
    /* webpackChunkName: "business" */ '@/views/business/prepayment/Detail.vue'
  )
const ServiceProviderSalesPerformance = () =>
  import(
    /* webpackChunkName: "business" */ '@/views/business/ServiceProviderSalesPerformance.vue'
  )

export default function (router) {
  // 我的渠道商的销售业绩
  router.push({
    path: '/partner/business/service-provider-sales-performance',
    name: 'ServiceProviderSalesPerformance',
    component: ServiceProviderSalesPerformance,
    meta: {
      isDistributor: true, // 校验权限是否为渠道商
      isFirstDistributor: true, // 校验是否为一级渠道商
    },
  })
  //我销售业绩
  router.push({
    path: '/partner/business/sales-performance-info',
    name: 'MySalesPerformance',
    component: MySalesPerformance,
    meta: {
      isDistributor: true, // 校验权限是否为渠道商
    },
  })
  // 客户后付费明细
  router.push({
    path: '/partner/business/postpaid',
    name: 'postpaid',
    component: Postpaid,
    meta: {
      isDistributor: true, // 校验权限是否为渠道商
    },
  })

  // 客户消费总览
  router.push({
    path: '/partner/business/consumption-overview',
    name: 'ConsumptionOverview',
    component: ConsumptionOverview,
    meta: {
      isDistributor: true, // 校验权限是否为渠道商
    },
  })
  // 客户预付费明细
  router.push({
    path: '/partner/business/prepayment/list',
    name: 'prepaymentList',
    component: prepaymentList,
    meta: {
      isDistributor: true, // 校验权限是否为渠道商
      keepAlive: true,
    },
  })
  // 客户预付费详情
  router.push({
    path: '/partner/business/prepayment/detail/:id',
    name: 'prepaymentDetail',
    component: prepaymentDetail,
    meta: {
      isDistributor: true, // 校验权限是否为渠道商
    },
  })
}
